<template>
    <div style="height: 600px; width: 100%">
        <l-map
        :zoom="zoom"
        :bounds="getBounds(markers)"
        :options="mapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        >
        <l-tile-layer
            :url="url"
            :attribution="attribution"
        />
        <l-marker 
            v-for="item in markers" :key="item.id"
            :lat-lng="getLatLng(item.latitude, item.longitude)"
            :icon="item.icon">
            <l-popup v-if="popup">
            <table>
                <tr>
                    <td colspan="2">{{ item.apelido || item.descricao }} </td>
                </tr>
                <tr>
                    <td><strong>Tipo:</strong></td>
                    <td>{{ item.tipo }}</td>
                </tr>
                <tr>
                    <td><strong>Situação:</strong></td>
                    <td>{{ item.situacao }}</td>
                </tr>
                <tr>
                    <td><a :href="item.url" target="_blank">mais informações...</a></td>
                </tr>
            </table>
            </l-popup>
        </l-marker>
        </l-map>
    </div>
</template>

<script>

import { latLng, polyline } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";

export default {
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 13,
      currentCenter: latLng(-27.5969, -48.5495),
      mapOptions: {
        zoomSnap: 0.5
      }
    };
  },
  props: {
    markers: {
      default: () => [],
      type: Array
    },
    zoom: {
        default: 13,
        type: Number
    },
    popup: {
        default: true,
        type: Boolean
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  methods: {
    getBounds(markers) {
      let latlngs = markers.filter(item => {
        return item.latitude && item.longitude
      }).map(item => {
        return [item.latitude, item.longitude]
      })
    
      let poligono = polyline(latlngs, {color: 'red'});

      let bounds = poligono.getBounds()
      // bounds.getCenter()
      return bounds.pad(0.1)
    },
    getLatLng(lat, lng) {
      return latLng(lat, lng)
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    }
  }
};
</script>